import {
    Component,
    OnInit,
    Input,
    trigger,
    state,
    style,
    transition,
    animate,
    OnChanges,
    SimpleChanges,
    HostBinding
} from '@angular/core'
import { Alert } from './shared/alert.model'

@Component({
    selector: 'col-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('in', style({ opacity: 1 })),
            state('void', style({ opacity: 0 })),
            transition('void <=> in', [
                animate('400ms cubic-bezier(0.250, 0.460, 0.450, 0.940)')
            ])
        ])
    ]
})
export class AlertComponent implements OnChanges {
    @Input() alert: Alert

    titulo: string
    texto: string
    cssClass: string

    @HostBinding('@fadeInOut') fadeInOut = 'in'

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if ('alert' in changes) {
            if (this.alert) {
                this.titulo = this.alert.titulo
                this.texto = this.alert.texto
                this.cssClass = this.alert.cssClass
            } else {
                this.titulo = undefined
                this.texto = undefined
                this.cssClass = undefined
            }
        }
    }

    fechar() {
        this.alert.fechar()
    }
}



// WEBPACK FOOTER //
// ./src/app/common/alert/alert.component.ts